import React from 'react';
import clsx from 'clsx';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useSelector } from 'react-redux';
import { imagePickSize, getLocalTimeString } from 'utils/general';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from 'components/Avatar';
import signImg from 'assets/images/sign-icon-grey-30x30.png';
import './style.scss';

dayjs.extend(relativeTime);

const Notification = ({
  notification,
  myFocus = false,
  markRead,
  dismiss,
}) => {
  const {
    id: notificationId,
    title,
    body,
    sender,
    externalSenderName,
    externalSenderEmail,
    isRead,
    kind,
    createdAt,
    wedding,
    otherData,
    url,
    image,
  } = notification;
  const me = useSelector((state) => state.global.userInfo);

  const timeAgo = dayjs(createdAt).fromNow();
  const tooltipTitle = getLocalTimeString(createdAt);
  const name = sender?.fullname ? sender.fullname :
    externalSenderName !== '' ? externalSenderName : externalSenderEmail ?? '';

  // Logic copied directly from angular.
  const showWedding = me.loginWeddings > 1 || !!me.orgId;
  const scope = otherData?.checklist_task_description ?
    otherData.checklist_task_description : showWedding  && !!wedding?.name ?
    wedding?.name : '';

  const imagePath = image?.resolutions?.square60 ?
    `//${process.env.REACT_APP_AWS_CLOUDFRONT}/${imagePickSize(
      image,
      'square60',
    )}` : null;

  // Various icons used.
  const star = '\u2605';
  const dollarSign = '$';
  let avatarImagePath = null;
  let isAPIcon = false;
  let avatarIcon = null;

  // Logic for notification display.
  let disabled = !url;
  let titleInName = false;
  let dismissOnClick = false;
  let avatar = '';
  const newWindow = url && url?.substr(0, 10) === '/document/';

  if (sender) {
    if (sender.profileImage) {
      avatarImagePath = `//${process.env.REACT_APP_AWS_CLOUDFRONT}/${imagePickSize(
        sender.profileImage,
        'square60',
      )}`;
      avatar=false;
    }
    else {
      avatar = sender?.initials ?? '';
    }
    dismissOnClick = true;

    if (kind === 'org.member-added') {
      disabled = false;
    }
  }

  switch (kind) {
    case 'org.listing.review':
      avatar = star;
      isAPIcon = true;
      titleInName = true;
      break;

    case 'org.invoice.payment.past_due':
      titleInName = true;
      // Falls through
    case 'org.invoice.payment':
      avatar = dollarSign;
      break;

    case 'reminder.task':
    case 'reminder.task.involved':
    case 'reminder.task.broadcast':
      avatar = '\u2714';
      isAPIcon = true;
      titleInName = true;
      break;

    case 'reminder.wedding-vendor-payment':
      avatar = dollarSign;
      break;

    case 'org.bank.transfer':
      avatar = dollarSign;
      titleInName = true;
      break;

    case 'lead.document.countersign':
    case 'lead.document.accepted':
    case 'org.quote.accepted':
      avatarImagePath = signImg;
      titleInName = true;
      break;

    case 'document.questionnaire.submit':
      avatar = '\u003f';
      titleInName = true;
      break;

    case 'lead.inquiry.created':
      avatar = '\ue902';
      isAPIcon = true;
      titleInName = true;
      break;

    case 'email.lead':
      avatarIcon = (<FontAwesomeIcon icon={['fa', 'envelope']} />);
      titleInName = true;
      break;

    case 'welcome.signup':
      titleInName = true;
      break;

    default:
      break;
  }

  const action = () => {
    if (dismissOnClick) dismiss();
    markAsRead();
    if (!url) return false;
    if (newWindow) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  };

  const markAsRead = () => {
    markRead(notificationId);
  };

  return (
    <div className="notification-item__wrapper">
      <button
        className={clsx('notification-item', {
          'linked': !disabled,
          'unread': !isRead,
        })}
        onClick={action}
      >
        <div className="content">
          <div className="sender-photo">
            <Avatar
              size={50}
              borderSize={3}
              photo={avatarImagePath}
              text={avatar}
              icon={avatarIcon}
              className={clsx('notification-avatar', {
                'ap-icon': isAPIcon,
              })}
            />
          </div>
          <div className="content">
            <div className="sender-name">{titleInName ? title : name}</div>
            <a
              title={tooltipTitle}
              className="date"
            >{timeAgo}</a>
            <div className="title">{!titleInName ? title : ''}</div>
            <div className="body">
              {body}
            </div>
            <div className="scope">{scope}</div>
          </div>
          {imagePath && (
            <div className="image">
              <img src={imagePath}
                alt=""
              />
            </div>
          )}
        </div>
      </button>
      {!isRead && myFocus && (
        <button
          aria-label="Mark as read"
          className="button--unstyled button--notification-dismiss"
          onClick={markAsRead}
        >
          <span className="fa fa-close" />
        </button>
      )}
    </div>
  );
};

export default Notification;
